import React from 'react';
import {
  Box,
  Card,
  Skeleton,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Stack,
} from '@mui/material';
import TasksTableHead from './TasksTableHead';

function RequestsSkeleton() {
  return (
    <Box>
      <Stack direction="row" mb={3}>
        <Skeleton variant="text" width={150} height={40} />
        <Skeleton variant="circular" width={20} height={20} sx={{ ml: 1 }} />
      </Stack>
      <Card className="mb-5 position-relative">
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table sx={{ tableLayout: 'fixed', minWidth: 650 }}>
            <TasksTableHead title="Task Vault" />
            <TableBody>
              {Array.from({ length: 3 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="80%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="rounded" width={100} height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="rounded" width={100} height={24} />
                  </TableCell>
                  <TableCell sx={{ pr: 3 }}>
                    <Box display="flex" justifyContent="flex-end">
                      <Skeleton animation="wave" variant="circular" width={32} height={32} />
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
}

export default RequestsSkeleton;
